/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobPositionScopeFilter } from './jobPositionScopeFilter';


export interface JobPositionIncludeFilterItems { 
    relation?: JobPositionIncludeFilterItems.RelationEnum;
    scope?: JobPositionScopeFilter;
}
export namespace JobPositionIncludeFilterItems {
    export type RelationEnum = 'workExperiencePositions' | 'jobPositionCompetences' | 'jobPositionBusinessUnits' | 'company' | 'department' | 'area' | 'genre' | 'maritalStatus' | 'academicLevel' | 'businessUnits';
    export const RelationEnum = {
        WorkExperiencePositions: 'workExperiencePositions' as RelationEnum,
        JobPositionCompetences: 'jobPositionCompetences' as RelationEnum,
        JobPositionBusinessUnits: 'jobPositionBusinessUnits' as RelationEnum,
        Company: 'company' as RelationEnum,
        Department: 'department' as RelationEnum,
        Area: 'area' as RelationEnum,
        Genre: 'genre' as RelationEnum,
        MaritalStatus: 'maritalStatus' as RelationEnum,
        AcademicLevel: 'academicLevel' as RelationEnum,
        BusinessUnits: 'businessUnits' as RelationEnum
    };
}


